import React from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';

var MapWidget = function MapWidget(props) {
  return /*#__PURE__*/React.createElement(MapContainer, {
    center: [props.latitude, props.longitude],
    zoom: props.zoom ? props.zoom : "6",
    pitch: props.pitch ? props.pitch : "0",
    bearing: props.bearing ? props.bearing : "0",
    scrollZoom: props.scrollZoom ? props.scrollZoom : "false",
    pitchWithRotate: props.pitchWithRotate ? props.pitchWithRotate : "false",
    dragRotate: props.dragRotate ? props.dragRotate : "false"
  }, /*#__PURE__*/React.createElement(TileLayer, {
    url: "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
  }), /*#__PURE__*/React.createElement(Marker, {
    position: [props.latitude, props.longitude]
  }));
};

export default MapWidget;